const DEFAULT_VACATION_EVENT_TOOLTIP_MESSAGE =
    'You must first set up a default vacation event in your settings before using this feature.';
const VACATION_EVENT_EXTENSION_MISSING =
    'You must first enable Vacation & Annual Leave Management extension before using this feature';

export { DEFAULT_VACATION_EVENT_TOOLTIP_MESSAGE, VACATION_EVENT_EXTENSION_MISSING };
